import { ButtonType } from 'components/Form/Button/Button';

export const SIZE_CLASSNAMES: Record<Required<ButtonType>['size'], string> = {
  'extra-small': 'py-1',
  small: 'py-2',
  base: 'py-3',
  large: 'py-3',
  'extra-large': 'py-4',
};

export const defaultContainerClasses =
  'flex text-start items-center text-sm text-gray-700 relative pl-4 pr-4 hover:bg-gray-200 min-w-full gap-3 focus-visible:outline-hidden focus:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none';
